var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.3438,
    stroke: "#FAFBF8",
    strokeWidth: 1.3125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1457 26.0183C43.8957 27.0287 43.8958 29.5546 42.1458 30.565L23.3333 41.4264C21.5833 42.4367 19.3958 41.1738 19.3958 39.1531L19.3958 17.4303C19.3958 15.4095 21.5833 14.1466 23.3333 15.1569L42.1457 26.0183Z",
    fill: "#FAFBF8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play.b9b0963449d89d0715e69bf814286f25.svg";